import React from "react";
import { Paper, Box, Typography } from "@mui/material";

const RightSection = () => {
  return (
    <></>
  );
};

export default RightSection;
